import { Injectable,NgModule } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import * as CryptoJS from 'crypto-js';
import {Globals} from '.././globals';
@Injectable()
export class jobService {
    user:any;
    reqHeader = new HttpHeaders({ 'No-Auth':'True'});
  constructor(private http: HttpClient,private _global:Globals) {
    
  }
  readonly rootUrl = this._global.siteUrl;
  addrecruiter(userObj){  
    const body = {
      userObj: userObj,
      createdBy:userObj[0].userid,
    }
  
    return this.http.post(this.rootUrl + 'jobpost/addrecruiter', body);
  }

  posteditrecruiter(userObj){
    const body = {
      userObj: userObj,
      createdBy:userObj[3],
    }
    return this.http.post(this.rootUrl + 'jobpost/editrecruiter', body);
  }

  editgetrecruiter(userID){
    return this.http.get(this.rootUrl+"jobpost/geteditrecruiter?user="+btoa(userID))
   }

getrecruiterlist(userObj){
    var userType = userObj[4];
   return this.http.get(this.rootUrl+"jobpost/getrecruiter?start="+userObj[0]+"&end="+userObj[1]+'&search='+userObj[2]+'&t='+userType+'&u='+userObj[3].id);
   
  }
     addjobdetail(Obj){
        const body = {
         Obj:Obj,
          userId:Obj.userId,
         }
        
         return this.http.post(this.rootUrl + 'jobpost/addjobdetail', body);
       
       }

       updatejobdetail(Obj,id){
    
        const body = {
          Obj:Obj,
          id:id, 
        }
       
        return this.http.post(this.rootUrl + 'jobpost/updatejobdetail', body);
      
      }

   getjobdetailslist(Obj){
        const body = {
          start:Obj[0],
          end:Obj[1],
          search:Obj[2],
          user:Obj[3],
         }
         return this.http.post(this.rootUrl + 'jobpost/getjobdetailslist', body);
       
       }
       delgalleryimage(id,image){
        const body = {
          id:id,
          image:image,

        }
        return this.http.post(this.rootUrl + 'jobpost/delgalleryimage', body);
       }

       editjobdetails(Id){
        const body = {
          id:btoa(Id),
         }
         return this.http.post(this.rootUrl + 'jobpost/getjobdetails', body,{ headers: this.reqHeader});
       
       }

       getannoucelist(obj){
        var reqHeader = new HttpHeaders({'No-Auth':'True'});
        return this.http.post(this.rootUrl+"jobpost/getannoucelist",obj,{headers:reqHeader});
      }
       deljob(Id){
        const body = {
          id: Id,
          isDeleted:1
        }
        return this.http.post(this.rootUrl + 'jobpost/deljob', body);
       }

       getjobfilterlist(Obj){
        return this.http.post(this.rootUrl + 'jobpost/getjobfilterlist',Obj,{ headers: this.reqHeader});
       }

       editjobdetailsbyuserId(uId,Id){
        const body = {
          uid:btoa(uId),
          id:btoa(Id),
         }
         return this.http.post(this.rootUrl + 'jobpost/getjobdetailsbyuserId', body,{ headers: this.reqHeader});
       
       }

       addgallery(galleryObj,id){
        const body = {
          galleryObj:galleryObj,
          userId:id
         }
        
         return this.http.post(this.rootUrl + 'jobpost/addgallery', body);
       
       }

       addjobrating(Obj){
        return this.http.post(this.rootUrl + 'jobpost/addjobrating', Obj);
       
       }

       getrecruiterReviewlist(userObj){
       return this.http.get(this.rootUrl+"jobpost/getrecruiterreview?start="+userObj[0]+"&end="+userObj[1]+'&search='+userObj[2]+'&u='+userObj[3].id+'&recType='+userObj[4]);
       
      }

      editreviewdetails(Id){
        const body = {
          id:btoa(Id),
         }
         return this.http.post(this.rootUrl + 'jobpost/getreviewdetails', body,{ headers: this.reqHeader});
       
       }

       updatereview(userObj){
        const body = {
          userObj: userObj,
          id:userObj[1],
          //createdBy:userObj[3],
        }
        return this.http.post(this.rootUrl + 'jobpost/updatereview', body);
      }

      deluser(userId){
        const body = {
          id: btoa(userId)
        }
        return this.http.post(this.rootUrl + 'jobpost/delreview', body);
      }

      getrecruiterReviewlistFront(userObj){
        console.log(userObj);
        return this.http.get(this.rootUrl+"jobpost/getrecruiterreviewfront?start="+userObj[0]+"&end="+userObj[1]+'&search='+userObj[2]+'&recId='+userObj[3]+'&revType='+userObj[4],{ headers: this.reqHeader});
        
       }     


       jobfulllist(jobType){
        const body = {
          jobType: jobType
        }
console.log('inside service',jobType);
        return this.http.post(this.rootUrl+"jobpost/typewisejobdetailslist",body,{ headers: this.reqHeader});
        
       }     

       
 }



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/job.service.ts